export function cellByIndex(index, gridSize) {
    var i = index % gridSize;
    var j = Math.floor(index / gridSize);
    return [i, j];
}
